export var CommonItems = [
    "Sunscreen",
    "Phone Charger",
    "Laptop Charger",
    "Toothpaste",
    "Swimsuit",
    "Laundry Bag",
    "First aid kit",
    "Umbrella",
    "Sunglasses", 
    "Snack",
    "Sweatshirt",
    "Pain Killers",
    "Hand Sanitizer",
    "Water Bottle"

]


/* https://www.cheatsheet.com/culture/common-things-people-always-forget-to-pack-for-vacation.html/ */